import { render, staticRenderFns } from "./UpdateMasterDiscountCode.vue?vue&type=template&id=1c8b6a2c"
import script from "./UpdateMasterDiscountCode.vue?vue&type=script&lang=js"
export * from "./UpdateMasterDiscountCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports